import classNames from 'classnames/bind';
import styles from './form.module.scss';
import { FormTextInputProps, getError } from './_text-input';
import FormError from './_error';
import React from 'react';
import Icon, { IconVariant } from '../icon/icon';

export enum RadioVariant {
  RADIO = 'radio',
  CHECKBOX = 'checkbox'
}

export default function FormRadio<T>({
  children,
  className,
  formik,
  name,
  onChange,
  type,
  value,
  variant,
  ...inputProps
}: FormTextInputProps<T> & { variant?: RadioVariant }): JSX.Element {
  const classesContext = classNames.bind(styles);
  const error = getError<T>(formik, name);

  return (
    <label className={classesContext(['radio_item', className])}>
      <input
        onChange={formik?.handleChange ?? onChange}
        type='radio'
        value={value}
        name={name}
        {...inputProps} />
      <span
        className={classesContext([
          'radio',
          {
            radio__error: error,
            radio_checkbox: variant === RadioVariant.CHECKBOX
          }
        ])}
      >
        {variant === RadioVariant.CHECKBOX ? (
          <span className={styles.radio_icon}>
            <Icon variant={IconVariant.CHECKBOX} />
          </span>
        ) : (
          <span className={styles.radio_icon} />
        )}
      </span>
      {children}
      {error && <FormError error={error} />}
    </label>
  );
}
